import { Layout } from "../../../components/Layout";
import { Column, Grid, Row } from "carbon-components-react";
import { useLocation } from "react-router-dom";

export default function RequestFormat() {
  const { pathname } = useLocation();
  return (
    <>
      <div className="doc-content">
        <h3 className="text-left pb-24 doc-title">Create Order Purchase</h3>
        <h4 className="pb-24 sub-title">Request Format</h4>
        <p className="other-text pb-8 ">
         <strong className="black">
            {" "}
            The Create Order (createOrder) operation{" "}
          </strong>{" "}
          is an initial and mandatory step when working with the order.{" "}
        </p>
        <p className="other-text pb-32">
          {" "}
          The operation involves the merchant or terminal logins. When using the
          merchant login, the <strong className="black pr-4">terminalId</strong>
          parameter should be additionally passed in the request.
        </p>

        <div className="doc-table mb-32">
          <div className="doc-table-td">
            <div className="table-left">URL</div>
            <div className="table-right">
              <a href="#" className="link">
                 {"https:///{path} where {path}"}
              </a>
              – relative path that is added to the URL address of the FES API
              Gateway application and indicates the type of the operation being
              executed (for details, refer to the txpg-frontend-api.yaml file
              and the current document).
            </div>
          </div>
          <div className="doc-table-td">
            <div className="table-left">HTTP method</div>
            <div className="table-right">
              <strong> POST/GET/PUT</strong> – depends on the operation type
            </div>
          </div>
          <div className="doc-table-td">
            <div className="table-left">Parameters of HTTP header</div>
            <div className="table-right">
              • Content-Type: application/json;
              <br />
              • If HTTP Basic authentication is used: <br />
              {"Authorization Basic <auth> where <auth>"} – compound user login and password represented
              as astring (in /: format) in the base64 encoding, where
              login_owner_type is the type of the login owner, i.e. TerminalSys,
              TerminalUser, Merchant, MultiMerchant, ConsumerOfMerch (see
              above). For example: Authorization: Basic
              VGVybWluYWxTeXMvTG9naW4xOlBhc3N3b3JkMTIzNA== that corresponds
              to“TerminalSys/Login1:Password1234”. <br />
              • If a login of the external user is used – the session ID, for
              example: TXPG-User-Session-ID: 210701-17155008-0lhzjr=
              <br />• Idempotence key, for example: TXPG-Idempotence- Key:
              123e4567-e89b-12d3-a456-426652340000
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
